var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.9 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M277.9 31.2c-3.3-12.3-12.9-22-25.1-25.3-22.1-6-110.9-6-110.9-6S53.2 0 31 6C18.8 9.3 9.2 18.9 5.9 31.2 0 53.5 0 100 0 100s0 46.5 5.9 68.8c3.3 12.3 12.9 22 25.1 25.3 22.1 6 110.9 6 110.9 6s88.8 0 110.9-6c12.2-3.3 21.8-13 25.1-25.3 5.9-22.3 5.9-68.8 5.9-68.8s.1-46.5-5.9-68.8m-165 111V57.8l74.2 42.2z"
  })));
};
export default SvgYoutube;